
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Punetomahabaleshwar() {



    const cardData =
    {
        keyword: '   Pune to Mahabaleshwar Urbania Bus Hire on Rent',
        heading: 'Samarth Travels:   Pune to Mahabaleshwar Urbania Bus Hire on Rent',
        headingDescription: 'Samarth Travels offers Pune to Mahabaleshwar Urbania bus hire on rent, perfect for family trips, group tours, and weekend getaways. Travel in comfort with our premium Force Urbania vans featuring AC, push-back seats, and ample space. With professional drivers, transparent pricing, and on-time service, Samarth Travels ensures a safe and relaxing journey to Mahabaleshwar.',

        top: 'Top Places to Visit in Mahabaleshwar with Samarth Travels',

       "topPlaces": [
    {
      "title": "Arthur’s Seat",
      "description": "Known as the 'Queen of all Points', Arthur’s Seat offers panoramic views of the dense valleys of Brahma-Arayana and the Savitri River. Located at an elevation of 1,470 meters, this viewpoint is famous for its unique rock formations and the optical illusion where light objects thrown down the valley are said to come back due to air pressure. It's a must-visit for nature lovers and photography enthusiasts."
    },
    {
      "title": "Elephant’s Head Point",
      "description": "Resembling the head of an elephant, this rock formation offers breathtaking views of the Sahyadri mountain range. Also known as Needle's Point, it's an ideal spot for witnessing mesmerizing sunrises and sunsets amidst serene surroundings."
    },
    {
      "title": "Venna Lake",
      "description": "A man-made lake constructed in 1842 by Shri Appasaheb Maharaj, Venna Lake is a popular tourist attraction offering boating and horse riding activities. Surrounded by lush greenery, it's a perfect spot for family outings and enjoying local street food."
    },
    {
      "title": "Mahabaleshwar Temple",
      "description": "An ancient temple dedicated to Lord Shiva, Mahabaleshwar Temple is a significant pilgrimage site. Built in the 16th century, it houses a 6-foot-long 'Swayambhu' Shiva Linga and is considered one of the most sacred temples in the region."
    },
    {
      "title": "Mapro Garden",
      "description": "Famous for its strawberry produce, Mapro Garden is a delightful place featuring a chocolate factory, restaurant, and a retail outlet selling fruit-based products. Visitors can enjoy fresh strawberry treats and learn about the processing of various fruit products."
    },
    {
      "title": "Lingmala Waterfall",
      "description": "Situated on the Mahabaleshwar-Pune road, Lingmala Waterfall cascades from a height of 600 feet, offering a spectacular sight, especially during the monsoon season. The surrounding area is ideal for nature walks and picnics."
    },
    {
      "title": "Pratapgad Fort",
      "description": "Located 24 kilometers from Mahabaleshwar, Pratapgad Fort is a historical site where the famous battle between Chhatrapati Shivaji Maharaj and Afzal Khan took place in 1659. The fort offers panoramic views and insights into Maratha history."
    },
    {
      "title": "Wilson Point",
      "description": "As the highest point in Mahabaleshwar at 1,439 meters, Wilson Point is renowned for offering both sunrise and sunset views. The vast plateau with three watchtowers provides a 360-degree view of the surrounding landscape."
    },
    {
      "title": "Chinaman’s Falls",
      "description": "Once maintained by Chinese prisoners, Chinaman’s Falls is a captivating waterfall that plunges from a height amidst dense forests. It's a serene spot for nature lovers and photographers."
    },
    {
      "title": "Tapola (Mini Kashmir)",
      "description": "Known as the 'Mini Kashmir' of Maharashtra, Tapola is a small village near Mahabaleshwar famous for its picturesque Shivsagar Lake. Visitors can indulge in boating, kayaking, and enjoy the tranquil beauty of the region."
    }
  ],

"services": [
    {
        "name": "Rent Urbania Bus for Pune to Mahabaleshwar Trip",
        "description": "Plan a relaxing getaway from Pune to Mahabaleshwar with Samarth Travels’ Urbania bus rental. Our comfortable and well-equipped Urbania buses ensure a smooth and scenic travel experience for families, groups, and corporate teams."
    },
    {
        "name": "Pune to Mahabaleshwar Luxury Urbania Bus Hire",
        "description": "Travel in unmatched comfort and style with our luxury Urbania buses from Pune to Mahabaleshwar. Ideal for corporate getaways, weddings, or premium family trips, the ride features plush interiors, AC, and experienced drivers."
    },
    {
        "name": "Affordable Pune to Mahabaleshwar Urbania Bus Rental",
        "description": "Looking for a budget-friendly way to explore Mahabaleshwar? Samarth Travels offers affordable Urbania bus rental services from Pune, providing comfort and reliability without compromising on quality."
    },
    {
        "name": "Rent a Force Urbania Bus for Pune to Mahabaleshwar Tour",
        "description": "Explore the hills of Mahabaleshwar in a premium Force Urbania from Pune. With spacious seating and professional service, our rental is perfect for sightseeing tours, group holidays, and spiritual retreats."
    },
    {
        "name": "20-Seater Urbania Bus Hire Pune to Mahabaleshwar",
        "description": "Hire a 20-seater Urbania bus from Pune to Mahabaleshwar for small group tours, family outings, or team trips. Samarth Travels ensures safe and comfortable travel with well-maintained vehicles and courteous drivers."
    },
    {
        "name": "32-Seater Urbania Bus Rental Pune to Mahabaleshwar",
        "description": "For larger groups heading to Mahabaleshwar, our 32-seater Urbania bus rental from Pune is the perfect solution. Enjoy spacious seating, AC comfort, and hassle-free booking with Samarth Travels."
    },
    {
        "name": "Luxury Urbania Bus for Pune to Mahabaleshwar Sightseeing",
        "description": "Make your sightseeing tour to Mahabaleshwar memorable with our luxury Urbania bus rental. Featuring modern interiors, ample space, and smooth handling, it’s ideal for relaxed travel through scenic routes."
    },
    {
        "name": "Comfortable Urbania Bus Rental Pune to Mahabaleshwar",
        "description": "Comfort meets convenience in our Urbania bus rental from Pune to Mahabaleshwar. Perfect for families or mixed-age groups, this travel option guarantees a relaxed and enjoyable journey to the hills."
    },
    {
        "name": "Pune to Mahabaleshwar Urbania Bus Package on Rent",
        "description": "Book a complete Pune to Mahabaleshwar travel package with Samarth Travels, including a luxury Urbania bus, professional chauffeur, and customizable itinerary to suit your group’s travel preferences."
    },
    {
        "name": "Rent Urbania Bus for Family Trip to Mahabaleshwar",
        "description": "Planning a family escape to Mahabaleshwar? Rent a Force Urbania from Samarth Travels and enjoy a stress-free trip with spacious seating, clean interiors, and flexible pick-up and drop options."
    }
],
"tableData": [
    ["Rent Urbania Bus for Pune to Mahabaleshwar Trip", "Pune to Mahabaleshwar Luxury Urbania Bus Hire"],
    ["Affordable Pune to Mahabaleshwar Urbania Bus Rental", "Rent a Force Urbania Bus for Pune to Mahabaleshwar Tour"],
    ["20-Seater Urbania Bus Hire Pune to Mahabaleshwar", "32-Seater Urbania Bus Rental Pune to Mahabaleshwar"],
    ["Luxury Urbania Bus for Pune to Mahabaleshwar Sightseeing", "Comfortable Urbania Bus Rental Pune to Mahabaleshwar"],
    ["Pune to Mahabaleshwar Urbania Bus Package on Rent", "Rent Urbania Bus for Family Trip to Mahabaleshwar"]
],


    

"whychoose": [
    {
        "WhyChooseheading": "Luxury Urbania Bus Hire from Pune to Mahabaleshwar",
        "WhyChoosedescription": "Samarth Travels offers top-tier Urbania bus hire services for Pune to Mahabaleshwar trips, combining comfort, style, and performance. Whether you're planning a family outing, corporate retreat, or weekend getaway with friends, our Force Urbania ensures a premium travel experience on this scenic hill route."
    },
    {
        "WhyChooseheading": "Premium Interiors for a First-Class Travel Experience",
        "WhyChoosedescription": "Our Force Urbania features luxurious leather seats, spacious interiors, pushback seating, and personal AC vents for every passenger. With smooth suspension and ample legroom, you’ll enjoy a peaceful, comfortable journey through the winding roads from Pune to Mahabaleshwar."
    },
    {
        "WhyChooseheading": "Experienced Chauffeurs for a Safe and Scenic Ride",
        "WhyChoosedescription": "Our Urbania rentals come with well-trained, courteous chauffeurs familiar with the Pune to Mahabaleshwar route. They prioritize safety, punctuality, and smooth driving—especially important for ghat sections—so your group can relax and enjoy the beautiful journey stress-free."
    },
    {
        "WhyChooseheading": "Ideal for Family Trips, Corporate Retreats, and Small Groups",
        "WhyChoosedescription": "The Urbania is perfect for mid-sized groups looking for a private, comfortable ride. It’s a great fit for families, corporate teams, or friends traveling together for a weekend escape or vacation in Mahabaleshwar with premium travel standards."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Value-Packed Packages",
        "WhyChoosedescription": "Our Pune to Mahabaleshwar Urbania hire rates are competitive and completely transparent. No hidden fees—just fair, value-driven pricing that includes chauffeur service, fuel, and quality assurance, giving you peace of mind and budget control for your trip."
    },
    {
        "WhyChooseheading": "24/7 Booking and Flexible Travel Timings",
        "WhyChoosedescription": "We understand that hill station trips require flexible planning. That’s why our Urbania rentals are available 24/7 to suit your preferred departure time—be it early morning or late night. Book easily online or via phone for a convenient experience."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Your health and safety are important to us. Our Urbania vehicles are sanitized before every journey, with regular maintenance to ensure smooth performance on long-distance routes like Pune to Mahabaleshwar."
    },
    {
        "WhyChooseheading": "Multiple Payment Options for Hassle-Free Booking",
        "WhyChoosedescription": "Choose the payment mode that works best for you—UPI, credit/debit cards, net banking, wallets, or cash. We offer a smooth and secure payment process to make your travel booking easy and stress-free."
    }
]






















    }

const faqData = [
    {
        id: 1,
        question: 'How can I book a Force Urbania from Pune to Mahabaleshwar with Samarth Travels?',
        answer: 'Booking a Force Urbania from Pune to Mahabaleshwar is easy with Samarth Travels. You can reserve your ride online or by calling our customer support team. Just share your travel date, group size, and pickup location, and we’ll handle the rest.',
    },
    {
        id: 2,
        question: 'What are the features of the Force Urbania for Pune to Mahabaleshwar travel?',
        answer: 'Our Force Urbania offers luxury pushback seating, air-conditioning, USB charging ports, ample legroom, premium interiors, and smooth suspension — ideal for a comfortable and stylish journey from Pune to Mahabaleshwar.',
    },
    {
        id: 3,
        question: 'Is the Force Urbania suitable for hill station trips like Mahabaleshwar?',
        answer: 'Yes, the Force Urbania is perfect for hill station drives. It offers a smooth and stable ride, even on curvy ghat roads, ensuring your journey to Mahabaleshwar is safe and enjoyable.',
    },
    {
        id: 4,
        question: 'How many people can travel in a Force Urbania?',
        answer: 'Depending on the configuration, our Urbania vehicles can seat 10 to 17 passengers comfortably. It’s ideal for families, friend groups, or small corporate teams heading outstation.',
    },
    {
        id: 5,
        question: 'What is included in the Pune to Mahabaleshwar Urbania rental?',
        answer: 'The rental includes the luxury Urbania vehicle, professional chauffeur, fuel charges, and in-cabin amenities. Tolls, parking, and other extras will be transparently listed before confirmation.',
    },
    {
        id: 6,
        question: 'Can I choose pickup points across Pune?',
        answer: 'Yes, we allow multiple pickup and drop-off points within Pune. Just let us know your preferred locations when booking, and we’ll arrange the most convenient route for your group.',
    },
    {
        id: 7,
        question: 'Is round-trip Urbania rental available for Mahabaleshwar?',
        answer: 'Yes, we offer both one-way and round-trip packages for Pune to Mahabaleshwar. Round-trip bookings are often more cost-effective and convenient if you plan to return the same day or next.',
    },
];

const testimonials = [
    {
        name: 'Mr. Alok Thakur',
        role: 'IT Professional',
        text: 'We booked the Force Urbania for our Pune to Mahabaleshwar family trip. The ride was extremely smooth, the vehicle was clean and luxurious, and the driver was very polite. Perfect service from Samarth Travels!',
        image: '/img/testimonial/testi_2_56.jpg',
    },
    {
        name: 'Mrs. Sneha Patankar',
        role: 'Travel Blogger',
        text: 'Our Urbania journey to Mahabaleshwar was top-notch! The van was in excellent condition and had every comfort we needed. Great service, punctuality, and support throughout. Highly recommend Samarth Travels!',
        image: '/img/testimonial/testi_2_57.jpg',
    },
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Urbania Bus Hire on Rent",
  "image": "https://samarthtravels.com/assets/images/pune-to-mahabaleshwar-urbania-bus.jpg",
  "description": "Rent a Luxury Urbania Bus for Pune to Mahabaleshwar trips. Affordable rental options for 20-seater and 32-seater Urbania buses. Comfortable buses available for family trips, sightseeing tours, and group travel.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/pune-to-mahabaleshwar-urbania-bus-hire-on-rent"
  }
};




    return (
        <div>


<Helmet>
  <title>Pune to Mahabaleshwar Urbania Bus Hire on Rent | Affordable & Luxury Options | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a Luxury Urbania Bus for Pune to Mahabaleshwar trips. Affordable rental options for 20-seater and 32-seater Urbania buses. Comfortable buses available for family trips, sightseeing tours, and group travel." 
  />
  <meta 
    name="keywords" 
    content="Rent Urbania Bus for Pune to Mahabaleshwar Trip, Pune to Mahabaleshwar Luxury Urbania Bus Hire, Affordable Pune to Mahabaleshwar Urbania Bus Rental, Rent a Force Urbania Bus for Pune to Mahabaleshwar Tour, 20-Seater Urbania Bus Hire Pune to Mahabaleshwar, 32-Seater Urbania Bus Rental Pune to Mahabaleshwar, Luxury Urbania Bus for Pune to Mahabaleshwar Sightseeing, Comfortable Urbania Bus Rental Pune to Mahabaleshwar, Pune to Mahabaleshwar Urbania Bus Package on Rent, Rent Urbania Bus for Family Trip to Mahabaleshwar" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/35.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomahabaleshwar;